export { default, lfLockModel } from 'liquid-fire/helpers/lf-lock-model';
